import React from "react";

import { Stack, SxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";

import { LogomarkIcon } from "@app/common/assets/icons";

const LogomarkWithGradient = ({ sx }: { sx?: SxProps<Theme> }) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        background: (theme) => theme.palette.gradients.read,
        padding: "6px",
        height: "36px",
        width: "36px",
        borderRadius: "4px",
        flexShrink: 0,
        ...sx,
      }}
    >
      <LogomarkIcon sx={{ height: "100%", width: "100%" }} />
    </Stack>
  );
};

export default LogomarkWithGradient;
